import React from 'react';
import { WizTreeSelectPlus } from '@/containers/common'
/**
 * 屏蔽组织类型查询
 * @param {*} api  
 * @returns 
 */
const columns = (api) => {
    return [
        {
            title: '组织名称',
            name: 'name',
            tableItem: {
                width: 200
            },
            searchItem: {}
        },
        {
            title: '组织编码',
            name: 'code',
            tableItem: {
                width: 200
            },
            searchItem: {}
        },
        {
          title: '组织类型',
          name: 'organizationNodeCategoryName',
          tableItem: {
            width: 100
          },
        },
        // {
        //     title: '组织类型',
        //     name: 'organizationNodeCategory',
        //     searchItem: {
        //         type: 'diy',
        //         diy: (props) => <WizTreeSelectPlus { ...props } />
        //     }
        // },
        {
            title: '组织状态',
            name: 'state',
            dict: [
                { code: 1, codeName: '有效' },
                { code: 0, codeName: '无效' },
            ],
            tableItem: {
                width: 100
            }
        }
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'organization/listByPage',
        ...api
    }
}

const organizationBrandNode = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        columns: columns(api),
        tableApi: tableApi(api)
    }
}

export default organizationBrandNode
